<template>
	<v-list-item style="border: 1px solid #e0e0e0; border-radius: 4px">
		<v-list-item-content>
			<v-list-item-title>
				<span class="primary--text">{{item.title_pt}}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
			<v-btn v-if="context == 'admin'" class="float-right" icon @click="showEdit = true">
        <v-icon color="primary">edit</v-icon>
      </v-btn>
      <v-dialog v-model="showEdit" width="50%">
        <v-card>
          <v-card-title class="title primary--text mb-2 secondary">
						<translate>Edit</translate>
            <span key="exclusion" class="ml-1" v-if="exclusion" v-translate>Exclusion</span>
            <span key="inclusion" class="ml-1" v-else v-translate>Inclusion</span>
					</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.title_pt"
                    :label="$gettext('Title') + ' PT'"
                    filled
                    class="px-2"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.title_en"
                    :label="$gettext('Title') + ' EN'"
                    filled
                    class="px-2"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.title_es"
                    :label="$gettext('Title') + ' ES'"
                    filled
                    class="px-2"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-alert v-model="error" color="red" type="error">
                    <translate>Error</translate>
                    <span>{{errorMessage}}</span>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="showEdit = false">
              <translate>Cancel</translate>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="secondary"
              class="primary--text"
              @click="save"
              :loading="saving"
            >
              <span v-translate>Save</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
		</v-list-item-action>
  </v-list-item>
</template>

<script>
import axios from "axios";

export default {
  name: "ICDOtherItem",
  props: ["item", "exclusion", "context"],
  data: () => ({
    showEdit: false,
    saving: false,
    error: false,
    errorMessage: ""
  }),
  computed: {
    required() {
      return [v => !!v || this.$gettext("Required.")]
    }
  },
  methods: {
    getForm() {
      if(this.$refs.form.validate()) {
        const form = new FormData();
        form.append("title_pt", this.item.title_pt);
        form.append("title_en", this.item.title_en);
        form.append("title_es", this.item.title_es);
        return form;
      }
      return false;
    },
    save() {
      this.error = false;
      this.errorMessage = "";
      let form = this.getForm();
      if(form) {
        this.saving = true;
        let endpoint;
        if(this.exclusion) endpoint = "/exclusions/" + this.item.id + "/edit";
        else endpoint = "/inclusions/" + this.item.id + "/edit";
        axios
					.post(endpoint, form)
					.then(response => {
						console.log(response.data);
						this.saving = false;
						if (response.data.result == "ok") {
              this.item = response.data.item;
              this.showEdit = false;
            } else {
							this.error = true;
							this.errorMessage = response.data.error;
						}
					})
					.catch(error => {
						this.saving = false;
						this.error = true;
						console.log(error);
					});
      }
    }
  }
}
</script>